export default __webpack_public_path__ + "static/media/book10.4731dcc4.svg";